import type { PartnerCommissionItem } from "partner-commissions/partnerCommissionApi";

export function upsertPartnerCommission(
  commissions: PartnerCommissionItem[],
  commission: PartnerCommissionItem,
): PartnerCommissionItem[] {
  const existingIndex = commissions.findIndex(
    item => item.id === commission.id,
  );
  if (existingIndex === -1) {
    return [...commissions, commission];
  }

  const nextCommissions = [...commissions];
  nextCommissions[existingIndex] = commission;
  return nextCommissions;
}
